(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const message = document.querySelector('.contact-form__success, .contact-form__error');
    if (message) {
      message.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
